<myre-button
  [icon]="icon()"
  [theme]="ButtonTheme.Transparent"
  [height]="ButtonHeight.Small"
  (onClick)="onClick.emit($event)"
/>

@if (numberOfNotifications() > 0) {
  <span
    class="number-of-notifications"
    [class.three-digits]="numberOfNotifications() > 99"
    >{{ numberOfNotifications() < 100 ? numberOfNotifications() : '99+' }}</span
  >
}
